import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import * as Cookies from "js-cookie";

Vue.use(Vuex);

function getCookie(name) {
  const cookies = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`);
  return cookies ? cookies[1] : "";
}

function delete_cookie(name, path, domain) {
  if (getCookie(name)) {
    document.cookie =
      name +
      "=" +
      (path ? ";path=" + path : "") +
      (domain ? ";domain=" + domain : "") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}

export default new Vuex.Store({
  state: {
    user: {},
    clients: [],
    current_client: {
      info: null,
      cards: null,
      notes: null,
    },
    current_trainer: {},
    club: "",
    isAuth: false,
    cards: {
      plans: [],
      solos: [],
    },
    trainers: [],
    balance: [],
    schedule: {},
    current_event: {},
    current_activecard: {},
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
      state.isAuth = true;
    },
    SET_CLIENT(state, clients) {
      state.clients = clients;
    },
    SET_CURRENT_CLIENT(state, client) {
      state.current_client.info = client;
    },
    SET_PLAN_CARDS(state, cards) {
      state.cards.plans = cards;
    },
    SET_SOLO_CARDS(state, cards) {
      state.cards.solos = cards;
    },
    SET_CURRENT_CARDS(state, cards) {
      state.current_client.cards = cards;
    },
    SET_BALANCE(state, balance) {
      state.balance = balance;
    },
    SET_CLUB(state, club) {
      state.club = club;
    },
    LOG_OUT(state) {
      state.user = {};
      state.isAuth = false;
    },
    SET_CLUB_TRAINERS(state, trainers) {
      state.trainers = trainers;
    },
    SET_SCHEDULE(state, schedule) {
      state.schedule = schedule;
    },
    SET_CURRENT_EVENT(state, event) {
      state.current_event = event;
    },
    SET_CURRENT_TRAINER(state, trainer) {
      state.current_trainer = trainer;
    },
    SET_CURRENT_ACTIVECARD(state, card) {
      state.current_activecard = card;
    },
  },
  actions: {
    setCurrentActiveCard(context, card) {
      context.commit("SET_CURRENT_ACTIVECARD", card);
    },
    setCurrentTrainer(context, trainer) {
      context.commit("SET_CURRENT_TRAINER", trainer);
    },
    setCurrentEvent(context, event) {
      context.commit("SET_CURRENT_EVENT", event);
    },
    setSchedule(context, schedule) {
      context.commit("SET_SCHEDULE", schedule);
    },
    async setClubTrainers(context, trainers) {
      context.commit("SET_CLUB_TRAINERS", trainers);
    },
    logOutUser(context) {
      delete_cookie("access_token");
      delete_cookie("club_id");
      delete_cookie("role");
      delete_cookie("admin_id");
      delete_cookie("vuex");
      context.commit("LOG_OUT");
    },
    setUser(context, user) {
      context.commit("SET_USER", user);
    },
    async getClients(context) {
      var list = [];
      await axios
        .post(`${process.env.VUE_APP_API}/clients/all`, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then((response) => {
          list = response.data["Client_list"];
          context.commit("SET_CLIENT", list);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else {
            console.log(err);
          }
        });
    },
    async getClient(context, client_id) {
      var client = [];
      var list = [];
      await axios
        .get(`${process.env.VUE_APP_API}/clients/get/${client_id}`, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then((response) => {
          client = response.data.Message.Client;
          list = response.data.Message.Client.cards;
          context.commit("SET_CURRENT_CLIENT", client);
          context.commit("SET_CURRENT_CARDS", list);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
    async createClient(context, { client }) {
      let new_client = {};
      const payload = {
        cardnumber: client.client_cardnum,
        name: client.client_name,
        surname: client.client_surname,
        phonenum: client.client_phonenum,
        birthday: client.client_birthday,
        gender: client.client_gender,
      };
      let x = await axios
        .post(`${process.env.VUE_APP_API}/clients/create`, payload, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then(async (response) => {
          new_client = response.data.Message.Client;
          return new_client;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
          context.commit("SET_CURRENT_CLIENT", client);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          } else if (err.response.status === 400) {
            return "Exists";
          }
        });
      return x;
    },
    async getCards(context) {
      var planlist = null;
      await axios
        .get(`${process.env.VUE_APP_API}/cards/cardlist/`, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then((response) => {
          planlist = response.data["Card_list"];
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
      context.commit("SET_PLAN_CARDS", planlist);
      var sololist = null;
      await axios
        .get(`${process.env.VUE_APP_API}/solotrainings/get`, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then((response) => {
          sololist = response.data.Message.Trainings;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
      context.commit("SET_SOLO_CARDS", sololist);
    },
    async createCard(context, { card }) {
      const payload = {
        name: card.name,
        trainings: card.unlimited ? null : card.trainings,
        validity: card.validity,
        training_type: card.training_type,
        cost: card.cost,
        complex: card.complex,
        allowed_groups: card.groups,
        description: card.description,
      };
      await axios
        .post(`${process.env.VUE_APP_API}/cards/create`, payload, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then((response) => {
          console.log(response.status);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
    async getClientCards(context, cardnumber) {
      var list = [];
      const payload = {
        cardnumber: cardnumber,
      };
      await axios
        .post(`${process.env.VUE_APP_API}/clients/get/cards`, payload, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then((response) => {
          list = response.data["Cards"];
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
      context.commit("SET_CURRENT_CARDS", list);
    },
    async getCard(context, card_id) {
      var card = [];
      await axios
        .get(`${process.env.VUE_APP_API}/cards/get/${card_id}`, {
          headers: { Authorization: `Bearer ${getCookie("access_token")}` },
        })
        .then((response) => {
          card = response.data["Card"];
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
      return card;
    },
    async getBalance(context) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/money/day/?club_id=${getCookie("club_id")}`,
          { headers: { Authorization: `Bearer ${getCookie("access_token")}` } },
        )
        .then((response) => {
          context.commit("SET_BALANCE", response.data["Day"]);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
    },
  },
  getters: {
    isAuth: (state) => state.isAuth,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => Cookies.get(key),
        setItem: (key, value) => Cookies.set(key, value, { expires: 3 }),
        removeItem: (key) => Cookies.remove(key),
      },
    }),
  ],
});
